// extracted by mini-css-extract-plugin
export default {"app":"app_app__vRUKU","App-logo-spin":"app_App-logo-spin__UZ+RR"};